import {Spinner} from '@primer/react'

export const LoadingFallback = () => {
  return (
    <div className="d-flex flex-column flex-items-center tmp-py-3">
      <Spinner aria-label="Loading" />
    </div>
  )
}
